/**
 * 全宽导航布局：复用站点顶部导航，不限制页面内容宽度。
 */

import type { ReactElement } from 'react'
import { Outlet } from 'react-router-dom'
import { Navbar } from './Navbar'

export function WideNavbarLayout(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
